import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Note: Ensure the 'libs' path is correctly mapped in your tsconfig.json
import { useNotificationConext } from 'libs/additiv-react-signalr';

/** * Define the structure of a notification based on your SignalR implementation.
 * Replace 'any' with specific fields (e.g., id: string, message: string)
 */
export interface Notification {
    id: string | number;
    message?: string;
    isRead?: boolean;
    timestamp?: string | Date;
    [key: string]: any;
}

interface UseNotificationsReturn {
    onReadNotification: (id: string | number) => void;
    allNotifications: Notification[];
    errorNotifications: string | false | undefined;
}

export const useNotifications = (): UseNotificationsReturn => {
    const { t, i18n } = useTranslation();

    // Memoizing the error message based on the current language
    const errorMessage = useMemo(
        () => t('profileMenu.notifications.error'),
        [t, i18n.language],
    );

    const {
        notifications: allNotifications,
        readNotification: onReadNotification,
        error,
    } = useNotificationConext();

    return {
        onReadNotification,
        allNotifications: allNotifications || [],
        // Logic: returns the translated string if there is an error, otherwise false
        errorNotifications: error ? errorMessage : false,
    };
};
